import React from 'react'
import {FaFacebookF,FaInstagram,FaLinkedin} from 'react-icons/fa'
import { NavHashLink } from 'react-router-hash-link';
import myprofile from '../Assets/myprofile.jpg'


const Navbar = () => {
  return (
    <div className='lg:hidden  flex flex-col w-56 h-screen bg-navcolor text-white fixed top-0 z-40 left-0 items-center gap-4 justify-evenly max-h-screen overflow-y-auto'>
          {/* logo */}
          <NavHashLink     smooth to='/#home'>     <div className='flex flex-col relative justify-between items-center cursor-pointer'>
          <div className='bg-dpcolor w-44 h-44 rounded-full object-left flex items-center justify-center'>
          <img className='w-40 h-40 rounded-full' src={myprofile} alt='dp'/>
          </div>
          <h3 className=' font-extrabold font-sans text-lg text-white block'>Hardik chopra</h3>
        </div>
        </NavHashLink>
 
        {/* links */}
        <div className='flex flex-col text-white  capitalize text-xl  gap-6 items-center'>
          {/* <a href='#'>home</a> */}
          <NavHashLink     smooth to='/#home'>home</NavHashLink>
          <NavHashLink smooth to='/#about'>about me</NavHashLink>
          {/* <NavHashLink smooth to='/#whatido'>what i do</NavHashLink> */}
          <NavHashLink smooth to='/#Resume'>Resume</NavHashLink>
          <NavHashLink smooth to='/#Projects'>Projects</NavHashLink>
          <NavHashLink smooth to='/#Contact'>Contact</NavHashLink>
        </div>

        <div className='justify-self-end cursor-pointer flex gap-4'>
        <a href="https://www.facebook.com/profile.php?id=100093304591176" className='hover:text-blue-400'>
        <FaFacebookF/>
        </a>
        <a href="https://www.instagram.com/hardiichopra/" className='hover:text-red'>
        <FaInstagram/>
        </a>
        <a href="https://www.linkedin.com/in/hardik-chopra-648b28233" className='hover:text-blue-400'>
        <FaLinkedin/>  
        </a>
        </div>
    </div>
  )
}

export default Navbar;
